import { PageTypeId } from '../../const';
import { ModCaowijer } from '../../../../components/Icons/ModCaowijer';
import { DefaultNavigationStrategy } from '../../defaults/strategy';
import { platformAdminNavigationSchema, platformSupportNavigationSchema, platformUserNavigationSchema } from './schema';
import { navigationCodes } from '../../../../data/translations/navigationCodes';
import { ModJobs } from '../../../../components/Icons/ModJobs';
import { ModSubscriptions } from '../../../../components/Icons/ModSubscriptions';
import { ModGossip } from '../../../../components/Icons/ModGossip';
import { ModComponentModel } from '../../../../components/Icons/ModComponentModel';
import { ModSalaryInfo } from '../../../../components/Icons/ModSalaryInfo';
import { ModDocumentTemplate } from '../../../../components/Icons/ModDocumentTemplate';
import { ModEmployers } from '../../../../components/Icons/ModEmployers';
import { defaultFooterNavigationSchema } from '../../defaults/schema';

export class PlatformNavigationStrategy extends DefaultNavigationStrategy {
	override getSchema = () => {
		return {
			userNavigationItems: platformUserNavigationSchema,
			adminNavigationItems: platformAdminNavigationSchema,
			supportNavigationItems: platformSupportNavigationSchema,
			footerNavigationItems: defaultFooterNavigationSchema,
		};
	};

	override getIcons() {
		const iconsOverride = {
			[PageTypeId.CaoNewsList]: ModCaowijer,
			[PageTypeId.ApplicationList]: ModJobs,
			[PageTypeId.ShareJobBoardInstanceList]: ModJobs,
			[PageTypeId.ShareJobBoardList]: ModJobs,
			[PageTypeId.ApplicationForm]: ModJobs,
			[PageTypeId.ShareLogList]: ModJobs,
			[PageTypeId.ShareJobPostList]: ModJobs,
			[PageTypeId.InvoiceComponentsList]: ModSubscriptions,
			[PageTypeId.CustomerInvoiceList]: ModSubscriptions,
			[PageTypeId.LabelTemplates]: ModGossip,
			[PageTypeId.NewsAdminList]: ModGossip,
			[PageTypeId.SurveyAdminList]: ModGossip,
			[PageTypeId.SurveyListOptOutList]: ModGossip,
			[PageTypeId.SurveyList]: ModGossip,
			[PageTypeId.TextModelList]: ModComponentModel,
			[PageTypeId.PayslipList]: ModSalaryInfo,
			[PageTypeId.CandidateReservationList]: ModSalaryInfo,
			[PageTypeId.PaymentList]: ModSalaryInfo,
			[PageTypeId.ProformaList]: ModSalaryInfo,
			[PageTypeId.DocumentList]: ModDocumentTemplate,
			[PageTypeId.DocumentSettingsList]: ModDocumentTemplate,
			[PageTypeId.InvoicePurchaseInvoice]: ModEmployers,
			[PageTypeId.InvoiceList]: ModEmployers,
		};

		return Object.assign({}, super.getIcons(), iconsOverride);
	}

	override getTitleCodes() {
		const overrides = {
			[PageTypeId.ModelMatrixList]: navigationCodes.contractConditionsList,
			[PageTypeId.ModelMatrixInstanceList]: navigationCodes.contractConditionsByBureauList,
			[PageTypeId.SavedFilterMyFiltersList]: navigationCodes.savedFilterPersonalList,
			[PageTypeId.SavedFilterSystemFiltersList]: navigationCodes.savedFilterOrganisationList,
			[PageTypeId.LabelList]: navigationCodes.labelConfigurationList,
			[PageTypeId.LabelPagesList]: navigationCodes.labelHomePage,
			[PageTypeId.AutomationList]: navigationCodes.smartTasksList,
			[PageTypeId.SubscriberList]: navigationCodes.subscribersJobAlertList,
			[PageTypeId.DomainValuesCAOMapping]: navigationCodes.caoAndCustomAgreementsMappingList,
			[PageTypeId.DomainValuesMapping]: navigationCodes.jobboardDomainsMappingList,
			[PageTypeId.SettingList]: navigationCodes.auditTrailSettingsLogList,
		};

		return Object.assign({}, super.getTitleCodes(), overrides);
	}
}
